module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KzQNhB/tc-custom/9781910859421.jpg?1705291371976",
      "alt": "This image is the cover for the book Man Made to Measure"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Man Made to Measure\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p'), _c('p', [_c('b', [_vm._v("In this ")]), _c('b', [_vm._v("“extremely moving . . . splendid, vigorous, warm-hearted novel” set in Ireland during WWI and the Easter Rising, two women are rivals in life and love (")]), _c('b', [_c('i', [_vm._v("Irish Press")])]), _c('b', [_vm._v(").")])]), _c('p', [_vm._v(" Dolly Devoy, a bold young Dubliner, has become very sure of herself since being promoted to work in the office of the local biscuit factory. Too sure of herself. ")]), _c('p', [_vm._v(" She should be a lord’s daughter, like Alice Delahunt, to be that confident. ")]), _c('p', [_vm._v(" For Alice the path looks smooth, with a glittering marriage to a hero of the Somme. But her husband, Stephen, is no hero to Alice, and she covets another. Her unlikely rival for the love of that man? One Dolly Devoy . . . ")]), _vm._v(" It is an age of great passion and, in Dublin, of seething unrest. Love and war leave no one untouched, and in this story of loss and longing, those who survive are changed forever. \n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elaine Crowley\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0